import { ITotal } from '~shared/modules/cart/models';
import { GaTrackingCheckoutService } from '~shared/modules/ga-tracking/utils/ga-tracking-checkout.service';
import { CartOfferLine } from '~shared/modules/shopping-cart-store';
import { CartFeatures } from '~shared/modules/shopping-cart-store/models';
import { ApplicationEventType } from '../constants';
import { ApplicationEvent } from './application-event.model';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';

export class CheckoutReviewOrderInfoApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.ReviewOrderInfo;

  constructor(
    private cartOfferLines: CartOfferLine[],
    private total: ITotal,
    private discountCode: string,
    private priceType: string,
    private paymentMethod: string,
    private cartFeatures: CartFeatures,
  ) {}

  getPayload(): any {
    const shipping = this.priceType === PriceTypes.b2b ? this.total?.netShippingCostTotal : this.total?.shippingCostTotal;

    return {
      currency: 'EUR',
      ...GaTrackingCheckoutService.getAuthorizeFlow,
      coupon: this.discountCode,
      value: this.total?.total ? +this.total.total : null,
      price_type: this.priceType,
      payment_method: this.paymentMethod,
      ecommerce: {
        items: GaTrackingCheckoutService.getItemsForApplicationEvent(this.cartOfferLines, this.cartFeatures),
        shipping,
      },
    };
  }

  get payment_method(){
    return this.paymentMethod
  }
}
